import { GTBookingV2Status } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const statusMessages = defineMessages({
  [GTBookingV2Status.Confirmed]: {
    id: 'dictionary.confirmed',
    defaultMessage: 'Confirmed'
  },
  [GTBookingV2Status.Reserved]: {
    id: 'dictionary.reserved',
    defaultMessage: 'Reserved'
  },
  [GTBookingV2Status.Incomplete]: {
    id: 'dictionary.incomplete',
    defaultMessage: 'Incomplete'
  },
  [GTBookingV2Status.Failed]: {
    id: 'dictionary.failed',
    defaultMessage: 'Failed'
  },
  [GTBookingV2Status.Paid]: {
    id: 'dictionary.paid',
    defaultMessage: 'Paid'
  },
  [GTBookingV2Status.Cancelled]: {
    id: 'dictionary.cancelled',
    defaultMessage: 'Cancelled'
  },
  [GTBookingV2Status.PartiallyConfirmed]: {
    id: 'dictionary.partiallyConfirmed',
    defaultMessage: 'Partially confirmed'
  }
})
